import { NgModule } from '@angular/core';

import { ItvFileSizePipe } from '@shared/pipes/file-size.pipe';
import { ItvCurrencyPipe } from '@shared/pipes/itv-currency.pipe';
import {
  ItvDatePipe,
  ItvDateTimeCustomFormatPipe,
  ItvDateTimePipe,
  ItvDateTimeWithRestrictionsPipe,
  ItvFromNowPipe,
  ItvTimePipe,
} from '@shared/pipes/itv-date.pipe';
import { ItvNumberPipe, ItvNumberWithFormattingsPipe } from '@shared/pipes/itv-number.pipe';
import { KeyValuePipe } from '@shared/pipes/key-value.pipe';
import { MeasurementPipe } from '@shared/pipes/measurement/measurement.pipe';
import { ImageSourcePipe } from '@shared/pipes/string-pipes/image-source.pipe';
import { TranslateInsensitivePipe } from '@shared/pipes/translate-insensitive.pipe';

@NgModule({
  imports: [
    ImageSourcePipe,
    ItvNumberPipe,
    ItvNumberWithFormattingsPipe,
    ItvCurrencyPipe,
    ItvDateTimeWithRestrictionsPipe,
    ItvDateTimeCustomFormatPipe,
    MeasurementPipe,
    ItvDatePipe,
    ItvTimePipe,
    ItvDateTimePipe,
    KeyValuePipe,
    ItvFileSizePipe,
    ItvFromNowPipe,
    TranslateInsensitivePipe,
  ],
  exports: [
    ItvNumberPipe,
    ItvNumberWithFormattingsPipe,
    ItvCurrencyPipe,
    ItvDateTimeWithRestrictionsPipe,
    ItvDateTimeCustomFormatPipe,
    MeasurementPipe,
    ItvDatePipe,
    ItvTimePipe,
    ItvFromNowPipe,
    ItvDateTimePipe,
    KeyValuePipe,
    ImageSourcePipe,
    ItvFileSizePipe,
    TranslateInsensitivePipe,
  ],
})
export class PipesModule {}
